var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClaritySendEnabled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 8,
    fill: "#CCF0FC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.6686 12C20.4917 12 20.3222 12.0702 20.1971 12.1953C20.0721 12.3203 20.0019 12.4899 20.0019 12.6667V15.3333C20.0019 15.5101 19.9316 15.6797 19.8066 15.8047C19.6816 15.9298 19.512 16 19.3352 16H12.9419L13.8086 15.14C13.9341 15.0145 14.0046 14.8442 14.0046 14.6667C14.0046 14.4891 13.9341 14.3189 13.8086 14.1933C13.683 14.0678 13.5128 13.9973 13.3352 13.9973C13.1577 13.9973 12.9874 14.0678 12.8619 14.1933L10.8619 16.1933C10.8012 16.2567 10.7536 16.3315 10.7219 16.4133C10.6552 16.5756 10.6552 16.7577 10.7219 16.92C10.7536 17.0018 10.8012 17.0766 10.8619 17.14L12.8619 19.14C12.9239 19.2025 12.9976 19.2521 13.0788 19.2859C13.1601 19.3198 13.2472 19.3372 13.3352 19.3372C13.4232 19.3372 13.5104 19.3198 13.5916 19.2859C13.6728 19.2521 13.7466 19.2025 13.8086 19.14C13.871 19.078 13.9206 19.0043 13.9545 18.9231C13.9883 18.8418 14.0057 18.7547 14.0057 18.6667C14.0057 18.5787 13.9883 18.4915 13.9545 18.4103C13.9206 18.329 13.871 18.2553 13.8086 18.1933L12.9419 17.3333H19.3352C19.8657 17.3333 20.3744 17.1226 20.7494 16.7475C21.1245 16.3725 21.3352 15.8638 21.3352 15.3333V12.6667C21.3352 12.4899 21.265 12.3203 21.14 12.1953C21.0149 12.0702 20.8454 12 20.6686 12Z",
    fill: "#002840"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClaritySendEnabled);
export default __webpack_public_path__ + "static/media/clarity-send-enabled.bf80fd6587aa939eb97d28306113928f.svg";
export { ForwardRef as ReactComponent };